import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-white px-4 py-16 text-center">
      <div className="inline-flex items-center justify-center rounded-full bg-[#F4F1EA] text-[#163A2B] w-20 h-20 mb-6 shadow-sm">
        <i className="fa-solid fa-compass-slash text-4xl" />
      </div>
      <h1 className="text-4xl sm:text-5xl font-extrabold text-[#1C1E1D] tracking-tight font-display">
        404 — Siden blev ikke fundet
      </h1>
      <p className="mt-4 text-base sm:text-lg text-[#1C1E1D]/70 max-w-md mx-auto leading-relaxed">
        Beklager, men den side du leder efter findes ikke, er blevet flyttet eller er midlertidigt utilgængelig.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-md bg-[#163A2B] px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#1C1E1D] transition-colors cursor-pointer"
        >
          <i className="fa-solid fa-house mr-2 text-xs" /> Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center rounded-md border border-[#E2E2E0] bg-[#F4F1EA] px-6 py-3 text-sm font-semibold text-[#1C1E1D] hover:bg-[#E2E2E0] transition-colors cursor-pointer"
        >
          Kontakt support
        </Link>
      </div>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-white px-4 py-16 text-center">
      <div className="inline-flex items-center justify-center rounded-full bg-red-50 text-red-600 w-20 h-20 mb-6 shadow-sm border border-red-100">
        <i className="fa-solid fa-lock-keyhole text-4xl" />
      </div>
      <h1 className="text-4xl sm:text-5xl font-extrabold text-[#1C1E1D] tracking-tight font-display">
        403 — Adgang nægtet
      </h1>
      <p className="mt-4 text-base sm:text-lg text-[#1C1E1D]/70 max-w-md mx-auto leading-relaxed">
        Du har ikke tilladelse til at tilgå denne side eller ressource. Venligst kontakt administratoren, hvis du mener, dette er en fejl.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-md bg-[#163A2B] px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#1C1E1D] transition-colors cursor-pointer"
        >
          <i className="fa-solid fa-house mr-2 text-xs" /> Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center rounded-md border border-[#E2E2E0] bg-[#F4F1EA] px-6 py-3 text-sm font-semibold text-[#1C1E1D] hover:bg-[#E2E2E0] transition-colors cursor-pointer"
        >
          Kontakt os
        </Link>
      </div>
    </div>
  );
}
